import {ValueAndLabelModel} from '../../../../../common/model/valueAndLabel.model';
import {WithPermissionModel} from '../../../../../common/permission/api/entity/withPermission.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {PhoneModel} from '../../../../../common/phone/entity/phone.model';

export class UserSummary extends WithPermissionModel {
    id: number;
    email: string;
    phone: PhoneModel;
    name: string;
    gender: ValueAndLabelModel;
    admin: boolean;
    superUser: boolean;
    active: boolean;
    role: LovValueSummary;
    picturePublicUrl: string;
    color: string;
}
